import PropTypes from 'prop-types';
import clsx from 'clsx';

const formatDate = (iso) => {
  if (!iso) return null;
  try {
    return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(iso));
  } catch {
    return null;
  }
};

const ContributionsBadge = ({ count, plusEntitlementUntil, plusLifetime, proTrialUntil, isDarkTheme }) => {
  const plusLabel = plusLifetime
    ? 'Plus vitalício'
    : (plusEntitlementUntil ? `Plus até ${formatDate(plusEntitlementUntil)}` : 'Plus (Limitado)');
  const proLabel = proTrialUntil && new Date(proTrialUntil) > new Date()
    ? ` · Trial Pro até ${formatDate(proTrialUntil)}`
    : '';
  return (
    <div
      className={clsx(
        'text-xs rounded-lg px-2 py-1 inline-flex gap-2',
        isDarkTheme ? 'bg-gray-800 text-gray-200' : 'bg-gray-100 text-gray-700'
      )}
    >
      <span>{count} contribuiç{count === 1 ? 'ão' : 'ões'}</span>
      <span>·</span>
      <span>{plusLabel}{proLabel}</span>
    </div>
  );
};

ContributionsBadge.propTypes = {
  count: PropTypes.number,
  plusEntitlementUntil: PropTypes.string,
  plusLifetime: PropTypes.bool,
  proTrialUntil: PropTypes.string,
  isDarkTheme: PropTypes.bool,
};

ContributionsBadge.defaultProps = {
  count: 0,
  plusEntitlementUntil: null,
  plusLifetime: false,
  proTrialUntil: null,
  isDarkTheme: false,
};

export default ContributionsBadge;
